module.exports = __webpack_public_path__ + "static/media/indicatorAntenna.f21ea497.png";